export const website = {
  firstStep: {
    title: "Let's get started! Which template would you like to use?",
    subtitle:
      "Ready to create a stunning website? Let's start with the templates; then we'll move on to the colors.",
  },
  secondStep: {
    title: "Which color range best suits your brand?",
    subtitle: "Personalize your template with a touch of color",
  },
  thirdStep: {
    title: "Do you have great photos of your property?",
    titleLine2: "Upload them!",
    subtitle: "Upload the best photo of your property for the homepage",
  },
  fourthStep: {
    title: "Great. How about a name for your business?",
    subtitle:
      "A company's name and slogan boost recognition and reinforce your brand image.",
  },
  fifthStep: {
    title: "Do you have a logo for your brand?",
    subtitle:
      "For best results, use a vector design or a PNG with a transparent background. The ideal ratios are 2:1 or 1:1 (square image). The size should be 400px x 192px (min. height 60px). If you don't have a logo yet, we'll use your business name as the brand.",
  },
  livingstone: {
    navMain: "Main menu",
    navProperty: "Property",
    navMap: "Map",
    navGallery: "Gallery",
    navRates: "Rates",
    navAvailability: "Availability",
    navReviews: "Reviews",
    bookNow: "Book now",
    checkinCheckout: "Arrival → Departure",
    guests: "Guests",
  },
  tideway: {
    navMain: "Main menu",
    navProperty: "Property",
    navMap: "Map",
    navGallery: "Gallery",
    navRates: "Rates",
    navAvailability: "Availability",
    navReviews: "Reviews",
    bookNow: "Book now",
    checkinCheckout: "Arrival → Departure",
    guests: "Guests",
  },
};
